export default __webpack_public_path__ + "static/media/MONKEY.2fa4e6f5.gif";